export interface TripFeeDTO {
    id?: number;
    type: 'province' | 'city';
    name: string;              // 도명 또는 지역명
    tripFee?: number;          // 도: 고객 청구 금액
    tripCost?: number;         // 지역: 출장자 지불 비용
    note?: string | null;
}

export class TripFeeDTO {
    id?: number;
    type: 'province' | 'city' = 'province';
    name: string = '';
    tripFee?: number = 0;
    tripCost?: number = 0;
    note?: string | null = '';

    constructor(data?: Partial<TripFeeDTO>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

export class TripFeeSearchDTO {
    type?: 'province' | 'city';
    name?: string;
    minAmount?: number;
    maxAmount?: number;
    keyword?: string;
    page?: number = 1;
    rows?: number = 10;

    constructor(data?: Partial<TripFeeSearchDTO>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}